import request from 'lib/request';

export interface Response {
  code: number;
  data: CollectionListData;
  msg: string;
}

export interface CollectionListData {
  has_next: boolean;
  list: CollectionList[];
  page: number;
  size: number;
}

export interface CollectionList {
  /**
   * 可售卖的数量
   */
  available: number;
  /**
   * 是否free mint(1:是,0:否)
   */
  is_free_mint: number;
  /**
   * 封面
   */
  logo: string;
  /**
   * mint价格(btc)
   */
  mint_price: string;
  /**
   * 名称
   */
  name: string;
  /**
   * 开始售卖时间
   */
  start_time: number;
  /**
   * 状态(未开始:NOT_START, 进行中:IN_PROGRESS, 售罄:SOLD_OUT)
   */
  state: string;
  /**
   * nft总数
   */
  supply: number;
  /**
   * 访问路径
   */
  vanity_url: string;
}

export async function getCollectionList(page: number) {
  const res = await request<Response>('/nft_launchpad/collection_list', {
    params: {
      page: page,
      size: 20,
    },
  });
  return res?.data;
}
